import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  FaMedium,
  FaDev,
  FaLinkedin,
  FaGithub,
  FaCreditCard,
} from "react-icons/fa";
import { SiPhonepe, SiGooglepay, SiPaytm } from "react-icons/si";

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h4>Quick Links</h4>
          <ul>
            <li>
              <a href="#">Home </a>
            </li>
            <li>
              <a href="#">About</a>
            </li>
            <li>
              <a href="#">Services</a>
            </li>
          </ul>
        </FooterSection>
        <FooterSection>
          <h4>Follow Us</h4>
          <SocialLinks>
            <a
              href="https://medium.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaMedium />
            </a>
            <a href="https://dev.to" target="_blank" rel="noopener noreferrer">
              <FaDev />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://github.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGithub />
            </a>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <h4>Support</h4>
          <ul>
            <li>
              <a href="#">FAQs</a>
            </li>
            <li>
              <a href="#">Terms and Conditions</a>
            </li>
            <li>
              <a href="#">Privacy Policy</a>
            </li>
          </ul>
        </FooterSection>

        <FooterSection>
          <h4>Accepted Payment Methods</h4>
          <PaymentMethods>
            <IconWrapper>
              <SiPhonepe title="PhonePe" />
            </IconWrapper>
            <IconWrapper>
              <SiGooglepay title="Google Pay" />
            </IconWrapper>
            <IconWrapper>
              <SiPaytm title="Paytm" />
            </IconWrapper>
            <IconWrapper>
              <FaCreditCard title="Card Payment" />
            </IconWrapper>
          </PaymentMethods>
        </FooterSection>
      </FooterContent>

      <FooterCopyright>
        © 2025 Passport Service | Website Designed By Sudhanshu Gaikwad
      </FooterCopyright>
    </FooterContainer>
  );
};

export default Footer;

// Styled Components for the Footer
const FooterContainer = styled.footer`
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  color: #dee2e6;
  padding: 2rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border-top: 1px solid #353535;

  text-align: center;
  padding-bottom: 8px;
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  flex: 1;
  margin: 1rem;

  border-right: 1px solid #353535;

  &:last-child {
    border-right: none;
  }

  h4 {
    color: #dee2e6;
    margin-bottom: 1rem;
    font-weight: 600;
    font-size: 1rem;
  }

  ul {
    list-style-type: none;
    padding: 0;

    li {
      margin: 0.5rem 0;

      a {
        color: #dee2e6;
        text-decoration: none;
        transition: color 0.3s;
        font-size: 0.9rem;

        &:hover {
          color: #194bfd;
        }
      }
    }
  }
`;

const FooterCopyright = styled.p`
  font-size: 0.75rem;
  color: #dee2e6;
  border-top: 1px solid #353535;
  padding-top: 1rem;
  margin-bottom: 0px;
`;

const PaymentMethods = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 50px;
    margin: 0 10px;
    transition: transform 0.3s;

    &:hover {
      transform: scale(1.1);
    }
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    img {
      margin: 10px;
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;

  a {
    color: #dee2e6;
    font-size: 1.8rem;
    transition: color 0.3s ease, transform 0.3s ease;

    &:hover {
      color: #194bfd;
      transform: scale(1.2);
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    flex-wrap: wrap;
  }
`;
const IconWrapper = styled.div`
  font-size: 2.5rem;
  margin: 0 10px;
  color: #dee2e6;
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.2);
    color: #3f51ff;
  }

  @media (max-width: 768px) {
    margin: 10px;
  }
`;
